import type { AccountKey } from 'owa-client-types';
import type { BizChatCompositeKey, WindowKey } from 'owa-bizchat-types';

const sessionIdByKey: Map<BizChatCompositeKey, string> = new Map();

function getSessionKey(accountKey: AccountKey, windowKey: WindowKey): BizChatCompositeKey {
    return `${accountKey}_${windowKey}`;
}

export function setBizChatSessionId(
    accountKey: AccountKey,
    windowKey: WindowKey,
    sessionId: string
): void {
    const key = getSessionKey(accountKey, windowKey);
    sessionIdByKey.set(key, sessionId);
}

export function getBizChatSessionId(
    accountKey: AccountKey,
    windowKey: WindowKey
): string | undefined {
    const key = getSessionKey(accountKey, windowKey);
    return sessionIdByKey.get(key);
}

export function removeBizChatSessionId(accountKey: AccountKey, windowKey: WindowKey): void {
    const key = getSessionKey(accountKey, windowKey);
    sessionIdByKey.delete(key);
}

export function clearAllMainWindowBizChatSessionIds(mainWindowKey: WindowKey): void {
    for (const key of sessionIdByKey.keys()) {
        if (key.endsWith(mainWindowKey)) {
            sessionIdByKey.delete(key);
        }
    }
}
